// src/pages/ProjectDetails/SMA/SMA.jsx
import React, { useMemo, useState } from "react";
import ButtonComponent from "../../../components/uikit/components/Button/ButtonComponent";
import Addicon from "../../../assets/images/FaPlus.svg";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import "../SocialAnalysis/socialAnalysis.css";

import UrlGrid from "./UrlGrid";


const Section = ({ title, values, setValues, placeholder }) => {
  const addField = () => {
    if (values.length < 3) setValues([...values, ""]);
  };

  const updateValue = (idx, val) => {
    const copy = [...values];
    copy[idx] = val;
    setValues(copy);
  };

  const removeField = (idx) => {
    const copy = [...values];
    copy.splice(idx, 1);
    setValues(copy);
  };

  return (
    <div className="sma-card">
      <div className="sma-header">
        <div className="sma-header-left">
          <h3 className="sma-title">{title}</h3>
        </div>

        <div className="long" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img src={Addicon} alt="add" className="add-file-icon" />
          <ButtonComponent
            onClick={addField}
            variant="contained"
            btnType="primary"
            text="Add"
            className="btnPrimaryOutline small-btn"
            disabled={values.length >= 3}
            title={values.length >= 3 ? "Maximum 3 inputs reached" : `Add ${title} input`}
          />
        </div>
      </div>

      <div className="sma-inputs">
        {values.map((val, idx) => (
          <div className="sma-input-row" key={`${title}-${idx}`}>
            <input
              type="text"
              value={val}
              onChange={(e) => updateValue(idx, e.target.value)}
              placeholder={placeholder}
              className="sma-input"
            />
            <button
              type="button"
              className="sma-remove-btn"
              onClick={() => removeField(idx)}
              aria-label={`Remove ${title} input ${idx + 1}`}
              title="Remove"
            >
              <DeleteForeverIcon sx={{ color: '#FF0000' }} />
            </button>
          </div>
        ))}

        {values.length === 0 && (
          <div className="sma-empty-hint">No inputs yet. Click “Add” to create one.</div>
        )}
      </div>

      <div className="sma-footer">
        <span className="sma-limit-hint">Max 3 inputs</span>
      </div>
    </div>
  );
};


const DigitalSource = () => {
  const [otherInputs, setOtherInputs] = useState([""]);

  // Disable Save until at least one non-empty value exists
  const isSaveDisabled = useMemo(() => {
    const allInputs = [
      ...otherInputs
    ];
    return !allInputs.some(v => v.trim().length > 0);
  }, [otherInputs]);



  return (
    <div className="container-fluid pt-3">
      <div className="card MVOC-card w-100 border-none">
        <div className="flex">
          <div className="w-[70%]"><span className="project-title-text">Digital Source</span></div>
           <div className="w-[30%]"><span className="project-title-text">Other Digital Sources</span></div>
        </div>
        <div className="flex">
          <div className="w-[70%] pr-4">
            <UrlGrid />
          </div>
          <div className="w-px bg-gray-300"></div>
          <div className="w-[30%] pl-4">
            <Section
              title="Other"
              values={otherInputs}
              setValues={setOtherInputs}
              placeholder="Enter URL"
            />
          </div>
        </div>
      </div>

      <div className="d-flex w-100 my-3 justify-content-end">
        <ButtonComponent
          variant="contained"
          btnType="primary"
          text="Save & Proceed"
          className="btnPrimary"
          disabled={isSaveDisabled}
          title={isSaveDisabled ? "Please enter at least one URL or keyword" : "Save & Proceed"}
        />
      </div>
    </div>
  );
};

export default DigitalSource;
